import { render, staticRenderFns } from "./TeacherLedTrainingDashboard.vue?vue&type=template&id=ff6a8afa"
import script from "./TeacherLedTrainingDashboard.vue?vue&type=script&lang=js"
export * from "./TeacherLedTrainingDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports